import { gql, useMutation } from '@apollo/client';

// "Zu Klaus" ohne neuen Login (dev/klaus-sync/addendum-v1.5.md): der Server
// signiert einen 2-Minuten-Einmal-Link in Klaus, das Frontend leitet sofort weiter.
const KLAUS_HANDOFF_URL = gql`
  mutation KlausHandoffUrl($next: String, $src: String) {
    klausHandoffUrl(next: $next, src: $src)
  }
`;

export function useKlausHandoffMutation() {
  return useMutation<{ klausHandoffUrl: string }, { next?: string | null; src?: string | null }>(KLAUS_HANDOFF_URL);
}
